import { render, staticRenderFns } from "./PurchaseInfoLedgersMobile.vue?vue&type=template&id=4e86c220&scoped=true"
import script from "./PurchaseInfoLedgersMobile.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoLedgersMobile.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfoLedgersMobile.vue?vue&type=style&index=0&id=4e86c220&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e86c220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e86c220')) {
      api.createRecord('4e86c220', component.options)
    } else {
      api.reload('4e86c220', component.options)
    }
    module.hot.accept("./PurchaseInfoLedgersMobile.vue?vue&type=template&id=4e86c220&scoped=true", function () {
      api.rerender('4e86c220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoLedgersMobile.vue"
export default component.exports